import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/app/components/ui/alert-dialog';
import { usePreviousDayJSAWarning } from '@/hooks/use-previous-day-jsa-warning';
import { formatDateOnly } from '@/lib/date-utils';

interface PreviousDayJSAPromptProps {
  projectId: number | null;
  enabled?: boolean;
}

export function PreviousDayJSAPrompt({ projectId, enabled = true }: PreviousDayJSAPromptProps) {
  const { prompt, close, dismiss } = usePreviousDayJSAWarning(projectId, enabled);

  return (
    // "Not now", Escape and clicking outside all count as a dismissal.
    <AlertDialog
      open={prompt !== null}
      onOpenChange={(open) => {
        if (!open) dismiss();
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Close yesterday&apos;s JSA?</AlertDialogTitle>
          <AlertDialogDescription>
            {prompt
              ? `"${prompt.title}" from ${formatDateOnly(prompt.date)} is still open. Close it now?`
              : null}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Not now</AlertDialogCancel>
          <AlertDialogAction
            onClick={(event) => {
              // Keep Radix from treating this as a dismissal; the dialog
              // closes (or moves to the next open JSA) once this one is handled.
              event.preventDefault();
              close();
            }}
          >
            Close JSA
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
